import ErrorResponse from '../Models/ErrorResponse';
import { UATConstants, HttpVerbs } from '../Common/Models/UATConstants';
import { ServiceFactoryClientExecuteApi } from '../Common/Services/ServiceFactoryToExecuteApi';

export class QueryActions {
  public static MigrateUserViews(
    viewIds: string[],
    onRequestSuccess: (isSuccess: boolean) => void
  ) {
    const url = `${UATConstants.ApiPaths.MigrateUserViews}`;
    const apiRequest = { viewIds };
    ServiceFactoryClientExecuteApi.ExecuteAdoRequest<any>(
      url,
      [],
      HttpVerbs.post,
      viewIds,
      (response: boolean) => onRequestSuccess(response),
      (response: ErrorResponse) => null,
      false
    );
  }

  public static MigrateSharedViews(
    viewIds: string[],
    onRequestSuccess: (isSuccess: boolean) => void
  ) {
    const url = `${UATConstants.ApiPaths.MigrateSharedViews}`;
    const apiRequest = { viewIds };
    ServiceFactoryClientExecuteApi.ExecuteAdoRequest<any>(
      url,
      [],
      HttpVerbs.post,
      viewIds,
      (response: boolean) => onRequestSuccess(response),
      (response: ErrorResponse) => onRequestSuccess(false),
      false
    );
  }
}
